import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const ProfilePage = () => (
  <Layout>
    <SEO description="おすすめ書籍一覧" title="実務のGo" />
    <section class="section">
      <div class="container has-text-centered">
        <div class="content">
          <h1>おすすめ書籍一覧</h1>
        </div>
      </div>
      <hr/>
      <div class="container">
          <div class="columns">
              <div class="column is-2 is-offset-1">
                  <img src="https://m.media-amazon.com/images/I/51r7YcW0SbL.jpg" alt="スターティングGo言語" />
              </div>
              <div class="column is-8">
                  <h2 class="title">
                      <a href="https://www.amazon.co.jp/gp/product/B01FH3KRTI/ref=as_li_tl?ie=UTF8&camp=247&creative=1211&creativeASIN=B01FH3KRTI&linkCode=as2&tag=masayan11315-22&linkId=285bc4fe0e78934ef69796ddf3a64a3b" target="blank">スターティングGo言語</a>
                  </h2>
                  <p>初めてGO言語を学習する人に最適の本です。</p>
                  <p>公式サイトやネットの情報では理解しにくという人にオススメです。</p>
                  <p>かなり噛み砕いて丁寧に説明されています。</p>
              </div>
          </div>
      </div>
      <hr />
      <div class="container">
          <div class="columns">
              <div class="column is-2 is-offset-1">
                  <img src="https://images-na.ssl-images-amazon.com/images/I/51bfBL9XdyL._SX390_BO1,204,203,200_.jpg" alt="Kubernetes完全ガイド"/>
              </div>
              <div class="column is-8">
                  <h2 class="title">
                      <a href="https://www.amazon.co.jp/dp/4295004804/ref=as_sl_pc_qf_sp_asin_til?tag=masayan11315-22&amp;linkCode=w00&amp;linkId=043d5c244aaeeb432338a9009206836b&amp;creativeASIN=4295004804" target="blank">Kubernetes完全ガイド</a>
                  </h2>
                  <p>
                      初めてKubernetesを学習する人に最適の本です。</p>
                      <p>Kubernetesはコンテナ管理のデファクトになっているので、ネットに情報はたくさんあります。</p>
                      <p>しかし、初めてKubernetesを学ぶ場合は書籍を利用することをオススメします。というのも、Kubernetesは動作させるのに必要な知識が多いので、断片的な知識になるネットより、まとまった知識を学べる書籍で学んだ方が良いです。
                  </p>
              </div>
          </div>
      </div>
      <hr/>
      <div class="container">
          <div class="columns">
              <div class="column is-2 is-offset-1">
                  <img src="https://images-na.ssl-images-amazon.com/images/I/51QsmvkObML._SX392_BO1,204,203,200_.jpg" alt="増補改訂版Java言語で学ぶデザインパターン入門"/>
              </div>
              <div class="column is-8">
                  <h2 class="title">
                      <a href="https://www.amazon.co.jp/gp/product/4797327030/ref=as_li_tl?ie=UTF8&camp=247&creative=1211&creativeASIN=4797327030&linkCode=as2&tag=masayan11315-22&linkId=ad9ade89c3ee3db13dbd38d805c944e4" target="blank">増補改訂版Java言語で学ぶデザインパターン入門</a>
                  </h2>
                  <p>伝説の名著。</p>
                  <p>プログラミングに関する本でこれより役に立つ本はないのではないでしょうか。</p>
                  <p>Javaで実装されていますが、デザインパターンの本質が詳しく説明されているので、他の言語でも応用が効きます。</p>
                  <p>必ず手元に置いておきたい本です。</p>
              </div>
          </div>
      </div>
    </section>
  </Layout>
)

export default ProfilePage
